<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="navbar-logo">
        <img src="../assets/logo.png" alt="GO Count" class="nav-logo">
        <span class="nav-brand">GO Count Object -Thing Counter</span>
      </div>
      
      <div class="navbar-menu" :class="{ 'active': menuActive }">
        <a href="#features" class="nav-link">Features</a>
        <a href="#screenshots" class="nav-link">Interface</a>
        <a href="#download" class="nav-link">Download</a>
        <a href="#about" class="nav-link">About Us</a>
      </div>
      
      <div class="navbar-action">
        <a href="#download" class="download-btn">Download App</a>
        <a href="mailto:sl9283191@gmail.com" class="contact-btn">Contact Us</a>
      </div>
      
      <div class="menu-toggle" @click="toggleMenu">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      menuActive: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
      const menuToggle = document.querySelector('.menu-toggle');
      if (this.menuActive) {
        menuToggle.classList.add('active');
      } else {
        menuToggle.classList.remove('active');
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  left: 0;
  border-bottom: 2px solid #4a9ad8;
}

.navbar-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  position: relative;
}

.navbar-logo {
  display: flex;
  align-items: center;
  background: linear-gradient(to right, #f0f7fc, #ffffff);
  padding: 10px 25px;
  border-radius: 30px;
  box-shadow: 0 2px 10px rgba(74, 154, 216, 0.1);
  flex-shrink: 0;
  max-width: 45%;
  min-width: 300px;
}

.nav-logo {
  width: 50px;
  height: auto;
  margin-right: 15px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  flex-shrink: 0;
}

.nav-brand {
  font-size: 1.8rem;
  font-weight: bold;
  color: #4a9ad8;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  background: linear-gradient(to right, #4a9ad8, #3a7ab6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1.2;
  display: inline-block;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.navbar-menu {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  margin-left: auto;
  margin-right: 300px;
}

.nav-link {
  color: #555;
  text-decoration: none;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.nav-link:hover {
  color: #4a9ad8;
  background-color: rgba(74, 154, 216, 0.1);
}

.navbar-action {
  position: absolute;
  display: flex;
  gap: 15px;
  right: 20px;
}

.download-btn, .contact-btn {
  padding: 10px 20px;
  border-radius: 30px;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s;
  white-space: nowrap;
}

.download-btn {
  background: linear-gradient(to right, #4a9ad8, #3a7ab6);
  color: white;
  box-shadow: 0 2px 10px rgba(74, 154, 216, 0.2);
}

.contact-btn {
  background: white;
  color: #4a9ad8;
  border: 2px solid #4a9ad8;
  box-shadow: 0 2px 10px rgba(74, 154, 216, 0.1);
  display: block;
}

.download-btn:hover, .contact-btn:hover {
  transform: translateY(-2px);
}

.download-btn:hover {
  box-shadow: 0 4px 15px rgba(74, 154, 216, 0.3);
}

.contact-btn:hover {
  box-shadow: 0 4px 15px rgba(74, 154, 216, 0.2);
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  cursor: pointer;
  position: absolute;
  right: 15px;
  z-index: 1001;
}

.bar {
  width: 100%;
  height: 3px;
  background-color: #4a9ad8;
  border-radius: 3px;
  transition: all 0.3s ease;
}

@media (max-width: 1024px) {
  .navbar-menu {
    position: fixed;
    top: 0;
    right: -100%;
    width: 250px;
    height: 100vh;
    background-color: white;
    padding: 80px 20px 20px;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transition: right 0.3s ease;
    margin-left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column !important;
    flex-wrap: nowrap;
    justify-content: flex-start;
    gap: 20px;
    margin-right: 0;
  }
  
  .navbar-menu.active {
    right: 0;
  }
  
  .navbar-menu .nav-link {
    width: 100%;
    padding: 12px 15px;
    border-radius: 8px;
    text-align: left;
    font-size: 1.1rem;
    border-bottom: 1px solid rgba(74, 154, 216, 0.1);
  }
  
  .menu-toggle {
    display: flex;
    right: 20px;
    position: absolute;
  }
  
  .navbar-action {
    display: none;
  }
  
  .navbar-logo {
    margin-left: -20px;
    max-width: 80%;
  }
  
  .menu-toggle.active .bar:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  
  .menu-toggle.active .bar:nth-child(2) {
    opacity: 0;
  }
  
  .menu-toggle.active .bar:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 20px 0;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
    border-bottom: 2.5px solid #4a9ad8;
  }
  
  .navbar-container {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 15px;
    position: relative;
    align-items: center;
  }
  
  .navbar-logo {
    padding: 10px 16px;
    margin-left: 0;
    background: linear-gradient(to right, #f0f7fc, #f8fcff);
    box-shadow: 0 3px 10px rgba(74, 154, 216, 0.15);
    border-radius: 25px;
    max-width: 88%;
    width: auto;
    display: flex;
    align-items: center;
    overflow: hidden;
    min-height: 55px;
  }
  
  .nav-logo {
    width: 36px;
    height: 36px;
    margin-right: 8px;
    flex-shrink: 0;
  }
  
  .nav-brand {
    font-size: 1.65rem;
    font-weight: bold;
    letter-spacing: -0.5px;
    white-space: nowrap;
    overflow: visible;
    text-overflow: unset;
    padding-right: 0;
    line-height: 1.1;
    word-spacing: -1px;
  }
  
  .menu-toggle {
    position: static;
    width: 28px;
    height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
  }
  
  .bar {
    height: 3px;
  }
}

@media (max-width: 480px) {
  .navbar {
    padding: 18px 0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-bottom: 2px solid #4a9ad8;
  }
  
  .navbar-container {
    padding: 0 10px;
    justify-content: space-between;
  }
  
  .navbar-logo {
    padding: 8px 13px;
    margin-left: 0;
    background: linear-gradient(to right, #f0f7fc, #f8fcff);
    box-shadow: 0 2px 8px rgba(74, 154, 216, 0.12);
    border-radius: 20px;
    max-width: 84%;
    width: auto;
    display: flex;
    align-items: center;
    overflow: hidden;
    min-height: 50px;
  }
  
  .nav-brand {
    font-size: 1.25rem;
    font-weight: bold;
    letter-spacing: -0.5px;
    white-space: nowrap;
    overflow: visible;
    text-overflow: unset;
    padding-right: 0;
    line-height: 1;
    word-spacing: -2px;
  }
  
  .nav-logo {
    width: 28px;
    height: 28px;
    margin-right: 6px;
    flex-shrink: 0;
  }
  
  .menu-toggle {
    width: 22px;
    height: 16px;
    position: static;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
  }
  
  .bar {
    height: 2.5px;
  }
}

@media (max-width: 360px) {
  .nav-brand {
    font-size: 1.05rem;
    letter-spacing: -0.6px;
    word-spacing: -2.5px;
  }
  
  .nav-logo {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
  
  .navbar-logo {
    padding: 6px 10px;
    max-width: 80%;
    overflow: hidden;
  }
}
</style>